import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/outline';

interface ComponentProps {
  suggestedEmail: string;
  onAccept: () => void;
  onDismiss: () => void;
}

function EmailSuggestion({ suggestedEmail, onAccept, onDismiss }: ComponentProps) {
  return (
    <div className="email-suggestion rounded-lg p-3 mt-2">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="email-suggestion-icon h-5 w-5" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-gray-900">
            Did you mean <strong>{suggestedEmail}</strong>?
          </p>
          <div className="mt-2 flex space-x-3">
            <button
              type="button"
              onClick={onAccept}
              className="text-sm font-medium text-gray-900 hover:text-gray-700 underline"
            >
              Yes, use this
            </button>
            <button type="button" onClick={onDismiss} className="text-sm font-medium text-gray-900 hover:text-gray-700">
              No, keep mine
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailSuggestion;
